import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { Exam } from "src/app/models/exam";
import { EventsHubService, ExamMessage, EXAMMESSAGETYPE, PAGEPROPERTY } from "src/app/services/eventshub.service";
import { PAGEOBJECTTYPE } from "src/app/models/pageobject";

@Component({
  selector: "hkt-pageui",
  templateUrl: "./pageui.component.html",
})
export class PageUiComponent implements OnChanges, OnDestroy {
  @Input("exam") exam: Exam;
  @Input("page") pageIndex: number;
  @Input("mode") mode: string;
  pageCount: number;
  pageIconClass: string;
  pageEvaluateShow: boolean;
  private onPagePropertyChangeSubscription: Subscription;

  constructor(private eventsHubService: EventsHubService) {
    this.exam = null;
    this.pageIndex = 0;
    this.mode = "";
    this.pageCount = 0;
    this.pageIconClass = "";
    this.pageEvaluateShow = false;

    this.onPagePropertyChangeSubscription = this.eventsHubService.onPagePropertyChange.subscribe(change => {
      if (change.type == PAGEPROPERTY.Icon) {
        this.pageIconClass = "page-icon page-icon-" + this.exam.pages[this.exam.currentPageIndex].pageIcon;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.onPagePropertyChangeSubscription) {
      this.onPagePropertyChangeSubscription.unsubscribe();
      this.onPagePropertyChangeSubscription = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.exam) {
      if (this.exam) {
        this.pageCount = this.exam.pages.length;
      }
    }
    if (changes.pageIndex) {
      this.pageIconClass = "page-icon page-icon-" + this.exam.pages[this.exam.currentPageIndex].pageIcon;

      if (this.mode == "evaluate") {
        this.pageEvaluateShow = this.hasEvaluation();
      } else {
        this.pageEvaluateShow = false;
      }
    }
  }

  private hasEvaluation(): boolean {
    let hasEvaluation = false;
    for (let obj of this.exam.pages[this.exam.currentPageIndex].objects) {
      if (obj.type == PAGEOBJECTTYPE.Evaluation) {
        hasEvaluation = true;
        break;
      }
    }

    return hasEvaluation;
  }

  onClickPrev(): void {
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "PrevPage()";
    this.eventsHubService.setExamMessage(msg);
  }

  onClickNext(): void {
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "NextPage()";
    this.eventsHubService.setExamMessage(msg);
  }

  onClickStart(): void {
    this.onClickNext();
  }

  onClickEvaluate(): void {
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "EvaluatePage()";
    this.eventsHubService.setExamMessage(msg);
  }

  onClickSubmit(): void {
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "SubmitExam()";
    this.eventsHubService.setExamMessage(msg);
  }
}
